import { useState, useEffect, useRef } from 'react';
import { VOICE_CALL } from '../../../../constants/voice-call-constants';
import { updateManagementAttributes, getManagementAttributes } from '../../../../../../util/APIUtils';
import { VIDEO_CALL } from '../../../../constants/video-call-constants';
import useUnleashHook from '../../../../../../v2/core/unleash/useUnleashHook';
import { UnleashService } from '../../../../../../v2/services';

const useCommunicationSecuritySettingsHook = ({ locationId }) => {
  const { isFlagEnabled } = useUnleashHook(UnleashService.FLAGS.VOICE_CALL_INSIGHTS);
  const [isVoiceIdRegistrationEnabled, setIsVoiceIdRegistrationEnabled] = useState({});
  const [isVoiceVideoInsightsEnabled, setIsVoiceVideoInsightsEnabled] = useState(false);
  const modalRef = useRef(null);
  useEffect(() => {
    fetchContactManagementAttributes();
  }, [locationId]);

  useEffect(() => {
    if (Object.keys(isVoiceIdRegistrationEnabled).length > 0 && isVoiceIdRegistrationEnabled.attributeValue !== undefined) {
      handleUpdateVoiceIdRegistrationAttribute();
    }
  }, [isVoiceIdRegistrationEnabled]);

  const updateInsightValue = (attributes) => {
    if (!isFlagEnabled()) {
      setIsVoiceVideoInsightsEnabled(true);
      return;
    }
    
    const filteredAttribute = attributes.filter(attribute => attribute.attributeValue == 'true' && ((attribute.attributeName === VOICE_CALL.VOICE_CALL_INSIGHTS) || (attribute.attributeName === VIDEO_CALL.VIDEO_CALL_INSIGHTS)));
    if (filteredAttribute.length > 0) { //LENGTH "2" MEANS VOICE_CALL_INSIGHTS & VIDEO_CALL_INSIGHTS BOTH ARE TRUE
      setIsVoiceVideoInsightsEnabled(true);
    }
  };

  const fetchContactManagementAttributes = async () => {
    try {
      setIsVoiceIdRegistrationEnabled({});
      const managementAttributes = await getManagementAttributes(locationId);
      updateInsightValue(managementAttributes.locationAttributes); //A METHOD TO UPDATE INSIGHTS
      if (managementAttributes?.locationAttributes && Array.isArray(managementAttributes.locationAttributes)) {
        const foundAttribute = managementAttributes.locationAttributes.find(
          (attribute) => attribute.attributeName === VOICE_CALL.VOICE_ID_REGISTRATION_ATTRIBUTE_KEY
        );

        if (foundAttribute) {
          setIsVoiceIdRegistrationEnabled({
            attributeId: foundAttribute.attributeId,
            attributeName: foundAttribute.attributeName,
            attributeValue: foundAttribute.attributeValue === 'true',
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeVoiceIdRegistrationAttribute = (event) => {
    event.target.checked
      ? setIsVoiceIdRegistrationEnabled({
        ...isVoiceIdRegistrationEnabled,
        attributeValue: event.target.checked,
      })
      : handleDisableVoiceIdRegistrationModal();
  };
  const handleUpdateVoiceIdRegistrationAttribute = async () => {
    try {
      await updateManagementAttributes({
        locationId,
        locationAttributes: [isVoiceIdRegistrationEnabled],
      });
    } catch (error) {
      console.error(error);
    }
  };

  const disableVoiceIdRegistrationConfirmation = () => {
    setIsVoiceIdRegistrationEnabled({
      ...isVoiceIdRegistrationEnabled,
      attributeValue: false,
    });
    handleDisableVoiceIdRegistrationModal();
  };
  const handleDisableVoiceIdRegistrationModal = () => {
    modalRef.current.toggleModal();
  };
  return {
    modalRef,
    isVoiceIdRegistrationEnabled,
    isVoiceVideoInsightsEnabled,
    handleChangeVoiceIdRegistrationAttribute,
    handleDisableVoiceIdRegistrationModal,
    disableVoiceIdRegistrationConfirmation,
  };
};

export default useCommunicationSecuritySettingsHook;
